import React from 'react';
import { Alert, Button } from 'antd';
import styles from './styles.module.scss';
import { ApimPageShell } from './apim-page-shell';
import { PageLoader } from './page-loader';
import { useApiPortal } from './use-api-portal';
import { StatsGrid } from './stats-grid';
import { GroupsSection } from './groups-section';

/*
 * API Portal overview screen — catalog stats and a browsable grid of API groups.
 */
export function ApiPortalScreen() {
    const { stats, allEndpoints, isLoading, hasError, displayGroups, retry } = useApiPortal();

    return (
        <ApimPageShell navSelectedId="apim" navType="others">
            {isLoading ? (
                <PageLoader />
            ) : hasError ? (
                <Alert
                    type="error"
                    showIcon
                    message="Failed to load the API Portal"
                    description={<Button onClick={retry}>Retry</Button>}
                />
            ) : (
                <>
                    <header>
                        <h1>
                            <img src="/icons/code.png" alt="" width={28} height={28} />
                            API Portal
                        </h1>
                    </header>
                    <p className={styles.mutedText} style={{ marginBottom: 24 }}>
                        Browse and try out DataStudio&apos;s documented APIs.
                    </p>
                    <StatsGrid stats={stats} />
                    <GroupsSection groups={displayGroups} allEndpoints={allEndpoints} />
                </>
            )}
        </ApimPageShell>
    );
}
